import React, {Component} from "react";
import {Link} from "react-router-dom";

class LeagueItem extends Component {
	render() {
		const {league, selectLeague} = this.props;

		return (
			<li>
				<input type="checkbox" value={league.id} id={`league-${league.id}`} onChange={selectLeague}/>
				<label htmlFor={`league-${league.id}`}>
					<Link to={`/line-leagues/${league.id}`}>{league.name}</Link>
				</label>
			</li>
		);
	}
}

export default LeagueItem;


// WEBPACK FOOTER //
// ./src/app/components/LineWidget/LeagueItem.js